import { useCallback } from 'react';

import { type AirActionTrackingLocation } from '@air/analytics';
import { useAirModal } from '@air/provider-modal';

import { CreateBoardModal } from '~/components/Modals/CreateBoardModal';
import { useActiveSubscriptionCallback } from '~/swr-hooks/subscriptions/useActiveSubscriptionCallback';

export const useCreateRootBoard = ({ trackLocation }: { trackLocation: AirActionTrackingLocation }) => {
  const [_showCreateBoardModal] = useAirModal(CreateBoardModal);
  const { activeSubscriptionCallback } = useActiveSubscriptionCallback();

  const showCreateBoardModal = useCallback(
    () =>
      activeSubscriptionCallback(() => {
        _showCreateBoardModal({ trackLocation });
      }),
    [activeSubscriptionCallback, _showCreateBoardModal, trackLocation],
  );

  return {
    showCreateBoardModal,
  };
};
